/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SaveStripeAmplifyCreditsPurchaseSessionDetailsFailed$Params {
  stripeSessionId: string;
}

export function saveStripeAmplifyCreditsPurchaseSessionDetailsFailed(http: HttpClient, rootUrl: string, params: SaveStripeAmplifyCreditsPurchaseSessionDetailsFailed$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, saveStripeAmplifyCreditsPurchaseSessionDetailsFailed.PATH, 'post');
  if (params) {
    rb.query('stripeSessionId', params.stripeSessionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

saveStripeAmplifyCreditsPurchaseSessionDetailsFailed.PATH = '/api/amplify-credits/save-stripe-amplify-credits-purchase-session-details-failed';
